import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./TermsAndConditions.css";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Heading,
  Checkbox,
  Alert,
} from "@americanexpress/dls-react";
import amexlogo from "../../assets/amex.png";
import { useUniqueId } from "../../hooks/useUniqueId";
import { no, yes } from "../Common/constants";

const TermsConditions = ({ isAgreed, getChecked, label, children }) => {
  const [showModal, setShowModal] = useState(false);
  const [hasReadTerms, setHasReadTerms] = useState(isAgreed);

  const { t } = useTranslation("common");
  const [isNotAtBottom, setIsNotAtBottom] = useState(true);
  const baseId = useUniqueId(`terms-and-conditions-${label.id}`);

  const handleScroll = (e) => {
    const bottom =
      e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight - 75;
    setIsNotAtBottom(!bottom);
  };

  const onAgree = () => {
    if (hasReadTerms) {
      getChecked(yes, label.id);
      setShowModal(!hasReadTerms);
    } else {
      getChecked(no, label.id);
    }
  };

  const onClose = () => {
    onAgree();
    setShowModal(false);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const handleTermsRead = () => {
    setHasReadTerms(!hasReadTerms);
  };

  return (
    <>
      <Checkbox
        label={t(label.checkboxLabel)}
        id={`${baseId}-modal-tc`}
        checked={hasReadTerms}
        className="button"
        onClick={toggleModal}
      />
      {!hasReadTerms && <Alert>{t("access.terms-check")}</Alert>}
      {showModal && (
        <Modal>
          <ModalHeader onClose={onClose}>
            <h2 className="fluid heading-3">{t(label.header)}</h2>
          </ModalHeader>

          <ModalBody onScroll={handleScroll} className="modalbody modalUK">
            <div className="padResponsiveExtraLr">
              <div className="row">
                <div className="col-xs-12">
                  <Heading
                    level={1}
                    headingStyle={"heading5"}
                    className="modalHeading"
                  >
                    <img
                      className="logo"
                      src={amexlogo}
                      alt="American Express"
                    />
                    <span className="titleText">{t(label.title)}</span>
                  </Heading>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12">{children}</div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <div className="floatLeft">
              <Checkbox
                id={`${baseId}-modal-acceptance`}
                disabled={isNotAtBottom}
                checked={hasReadTerms}
                label={t("termsConditionModal.acceptance")}
                onChange={handleTermsRead}
              />
            </div>

            <Button
              styleType="primary"
              disabled={!hasReadTerms}
              onClick={onAgree}
              className="button"
            >
              {t("termsConditionModal.next")}
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};

export default TermsConditions;
